
export const createShippingLabel = async (
  orderData,
  paymentIntentId,
  accessToken
) => {
  const requestShippingLabel = async () => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 25000);
    const requestBody = {
      orderId: orderData.id,
      paymentIntentId,
    };

    try {
      const shippingResponse = await fetch('/api/create-shipment', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
        },
        body: JSON.stringify(requestBody),
        signal: controller.signal,
      });
      const shippingData = await shippingResponse.json().catch(() => ({}));
      if (!shippingResponse.ok) {
        const error = new Error(
          shippingData.error || `Shipping API error (${shippingResponse.status})`
        );
        error.retryable = shippingResponse.status >= 500;
        throw error;
      }
      if (!shippingData.success) {
        throw new Error(shippingData.error || 'Shipping label creation failed');
      }
      return shippingData;
    } finally {
      clearTimeout(timeoutId);
    }
  };

  let lastError;
  for (let attempt = 1; attempt <= 2; attempt += 1) {
    try {
      return await requestShippingLabel();
    } catch (error) {
      let requestError = error;
      if (error.name === 'AbortError') {
        requestError = new Error('Shipping label generation timed out');
        requestError.retryable = true;
      }
      lastError = requestError;
      if (!requestError.retryable || attempt === 2) throw requestError;
      await new Promise((resolve) => setTimeout(resolve, 2000));
    }
  }

  throw lastError;
};
